$(document).ready(function () {
  let uploader = document.querySelector("[upload-container]");
  if (uploader) {
    let fileList = uploader.querySelector("[file-list]");
    let uploadButton = document.querySelector("[upload-files]");
    let browseButton = document.querySelector("[browse-files]");
    let loader = document.getElementById("upload-loader"); // loader

    let addFileToList = function (file) {
      let element = document.createElement("div");
      element.setAttribute("data-uid", file.uniqueIdentifier);
      element.classList.add("alert", "alert-info");
      let uploadProgress = document.createElement("div");
      uploadProgress.setAttribute("upload-progress", "");
      uploadProgress.classList.add("alert-warning");
      element.appendChild(uploadProgress);

      let deleteButton = document.createElement("div");
      deleteButton.setAttribute("remove-file", "");
      deleteButton.classList.add("btn", "btn-sm", "btn-danger");

      let deleteInner = document.createElement("i");
      deleteInner.classList.add("fa", "fa-trash");
      deleteButton.appendChild(deleteInner);

      deleteButton.addEventListener("click", function () {
        let index = r.files
          .map(function (e) {
            return e.uniqueIdentifier;
          })
          .indexOf(this.parentElement.getAttribute("data-uid"));
        r.removeFile(r.files[index]);
        fileList.removeChild(this.parentElement);
      });

      let errorDisplay = document.createElement("div");
      errorDisplay.setAttribute("upload-message", "");
      errorDisplay.classList.add("d-none");
      element.appendChild(errorDisplay);

      let fileName = document.createElement("div");
      fileName.setAttribute("file-name", "");
      fileName.textContent = file.name;
      element.appendChild(deleteButton);
      element.appendChild(fileName);
      fileList.appendChild(element);
    };

    let queryData = {
      _token: uploader.querySelector("input").value,
    };

    // Only append member_id if it exists on this page
    let memberId = uploader.getAttribute("data-member-id");
    let fileType = uploader.getAttribute("data-file-type");
    let createdBy = uploader.getAttribute("data-created-by");
    if (memberId) {
      queryData.member_id = memberId;
      queryData.file_type = fileType;
      queryData.created_by = createdBy;
    }

    let r = new Resumable({
      chunkSize: 0.5 * 1024 * 1024, // 512 KB
      simultaneousUploads: 3,
      testChunks: false,
      throttleProgressCallbacks: 1,
      target: uploader.getAttribute("data-route"),
      query: queryData,
    });

    r.assignBrowse(browseButton);
    r.assignDrop(uploader);
    r.on("fileAdded", function (file, event) {
      addFileToList(file.file);
    });
    r.on("fileProgress", function (file, message) {
      let fileElement = fileList.querySelector(
        '[data-uid="' + file.uniqueIdentifier + '"]'
      );
      fileElement.querySelector("[upload-progress]").style.width =
        file.progress() * 100 + "%";
    });
    r.on("fileSuccess", function (file, message) {
      let fileElement = fileList.querySelector(
        '[data-uid="' + file.uniqueIdentifier + '"]'
      );
      let uploadProgress = fileElement.querySelector("[upload-progress]");
      let successMessage = fileElement.querySelector("[upload-message]");

      uploadProgress.classList.remove("alert-warning");
      uploadProgress.classList.add("alert-success");
      uploadProgress.style.width = "100%";
      successMessage.classList.remove("d-none");
      successMessage.classList.add("success");
      // successMessage.textContent = message;

      let parsed;
      try {
        parsed = JSON.parse(message);
        successMessage.textContent = parsed.message || 'Upload complete.';
      } catch (e) {
        successMessage.textContent = parsed.message; // fallback
      }
    });
    r.on("fileError", function (file, message) {
      let fileElement = fileList.querySelector(
        '[data-uid="' + file.uniqueIdentifier + '"]'
      );
      let uploadProgress = fileElement.querySelector("[upload-progress]");
      let errorMessage = fileElement.querySelector("[upload-message]");

      uploadProgress.classList.remove("alert-warning");
      uploadProgress.classList.add("alert-danger");
      uploadProgress.style.width = "100%";
      errorMessage.classList.remove("d-none");
      errorMessage.classList.add("error");
      errorMessage.textContent = message;
    });

    uploadButton.addEventListener("click", function (e) {
      e.preventDefault();
      if (loader) loader.style.display = "block"; // show loader
      r.upload();
    });

    // Hide loader when everything is done
    r.on("complete", function () {
      if (loader) loader.style.display = "none"; // hide loader
    });
  }
});
